import { BrowserRouter, Routes, Route } from "react-router-dom";
import React from "react";
import "./App.css";
import "../src/Component/Modal/Modal.css";
import Home from "../src/View/Home/Index";
import Login from "./Athentication/Login";
import MainLayout from "./Layout/MainLayout";
import Privateroute from "./PrivateRoute/Privateroute";

//tody
import ManageUsers from "./pages/ManageUsers";
import ManageFaq from "./pages/ManageFaq";
import ManageContact from "./pages/ManageContact";
import TermsCondition from "./pages/TermsCondition";
import ManageProjectItems from "./pages/ManageProjectItems";
import ManageProject from "./pages/ManageProject";
import ManageUserEditForm from "./pages/ManageUserEditForm";
import ManageProjectDataUpload from "./pages/ManageProjectDataUpload";
import ManageUserNavigate from "./pages/ManageUserNavigate";
import ManageFaqForm from "./pages/ManageFaqForm";
import ItemView from "./pages/ItemView";
import ManageProjectForm from "./pages/ManageProjectForm";
import ManageItemUpdatedData from "./pages/ManageItemUpdatedData";
import InnerItems from "./pages/InnerItems";
import HomePage from "./pages/HomePage";
import HomepageDataPieChart from "./pages/HomepageDataPieChart";
import HomepageEdit from "./pages/HomepageEdit";
import Wbs from "./pages/Wbs";
import AssignProjectToUser from "./pages/AssignProjectToUser";
import DataUpload from "./pages/DataUpload";

const App = () => {
  localStorage.getItem("token") //sur2
  console.log("surajit", localStorage.getItem("token"), "usertoken")
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route element={<Privateroute />}>
            <Route element={<MainLayout />}>
              <Route path="/" element={<Home />} />
              {/* ------------------ Rehub components ------- */}
              <Route path="/manageusers" element={<ManageUsers />} />
              <Route path="/managefaq" element={<ManageFaq />} />
              <Route path="/managecontact" element={<ManageContact />} />
              <Route path="/termscondition" element={<TermsCondition />} />
              <Route path="/manageprojectitems" element={<ManageProjectItems />} />
              <Route path="/manageproject" element={<ManageProject />} />
              <Route path="/manageuserform" element={<ManageUserNavigate />} />
              <Route path="/managefaqform" element={<ManageFaqForm />} />
              <Route path="/itemview" element={<ItemView />} />
              <Route path="/manageprojectform" element={<ManageProjectForm />} />
              <Route path="/manageuseredit" element={<ManageUserEditForm />} />
              <Route path="/manageprojectdataupload" element={<ManageProjectDataUpload />} />
              <Route path="/manageitemupdateddata" element={<ManageItemUpdatedData />} />
              <Route path="/inneritems" element={<InnerItems />} />
              <Route path="/homepage" element={<HomePage />} />
              <Route path="/piechart" element={<HomepageDataPieChart />} />
              <Route path="/homepageedit" element={<HomepageEdit />} />
              <Route path="/wbs" element={<Wbs />} />
              <Route path="/assign-to-user" element={<AssignProjectToUser />} />
              <Route path="/data-upload" element={<DataUpload />} />

            </Route>
          </Route>
          <Route path="/login" element={<Login />} />


        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
